import React from 'react';
import {injectIntl, IntlShape} from 'react-intl';

type FormatOptionsType = Intl.NumberFormatOptions;

function createGlobalizeAdapter(intl: IntlShape) {
  return {
    getNumberFormatter: (options?: FormatOptionsType) => {
      return (value: number) => intl.formatNumber(value, options);
    },
    getCurrencyFormatter: (currency: string, options?: FormatOptionsType) => {
      return (value: number) =>
        intl.formatNumber(
          typeof value === 'string' ? parseFloat(value) : value,
          {style: 'currency', currency, ...options},
        );
    },
    // NEW: number parser shim
    getNumberParser: (_options?: FormatOptionsType) => {
      return (value: string | number) => {
        if (typeof value === 'number') return value;
        // remove all non-numeric except dot/minus
        const parsed = Number(value.replace(/[^\d.-]/g, ''));
        return isNaN(parsed) ? 0 : parsed;
      };
    },
  };
}

export interface WithGlobalizeProps {
  globalize: ReturnType<typeof createGlobalizeAdapter>;
}

export function withGlobalize<P extends WithGlobalizeProps>(
  WrappedComponent: React.ComponentType<P>,
) {
  const ComponentWithGlobalize = (
    props: Omit<P, keyof WithGlobalizeProps> & {intl: IntlShape},
  ) => {
    const {intl, ...rest} = props as any;
    const globalize = createGlobalizeAdapter(intl);

    return <WrappedComponent {...(rest as P)} globalize={globalize} />;
  };

  return injectIntl(ComponentWithGlobalize);
}
